import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  InputLabel,
  FormControl,
  TextField,
  Grid,
  MenuItem,
  Avatar,
  Select,
  Box,
  TablePagination,
  IconButton,
  Menu,
  Button,
} from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

import DataTable from "../../Table/DataTable";
import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import Moment from "moment";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { GetCountries } from "react-country-state-city";

import { SESSION_AUTH } from "../../../helpers/auth";
import { getModuleAllPermissions } from "../../../helpers/utils";
import { useNavigate } from "react-router-dom";
import { ToastManager } from "../../common/ToastContainer";
import { EVENTS_SERVICES } from "../../../services";
import FullPageProgress from "../../common/FullPageProgress";
import { INVESTOR_TYPE_LIST } from "../../../helpers/constants";
import { EventUserCSV } from "./EventUserCSV";

export default function EventUser(props) {
  const { module } = props;
  const { userSession, LOGOUT_USER_SESSION } = SESSION_AUTH();
  const navigate = useNavigate();
  const [dataFetched, setDataFetched] = useState(false);
  const [userData, setUserData] = useState("");
  const [loader, setLoader] = useState(false);
  const [modulePermissions, setModulePermissions] = useState();
  const [userList, setUserList] = useState([]);

  const [totalRows, setTotalRows] = useState(0);

  const [selectedUser, setSelectedUser] = useState("");
  const [showFullText, setShowFullText] = useState("");
  const [countriesList, setCountriesList] = useState([]);

  const defaultFilter = {
    page: 0,
    limit: 10,
    name: "",
    email: "",
    phoneNumber: "",
    investorType: "",
    work: "",
    country: "",
    createdAtFrom: "",
    createdAtTo: "",
    jobTitle: "",
  };

  const [filter, setFilter] = useState(() => {
    const urlParams = new URLSearchParams(window.location.search);
    let sufilter = { ...defaultFilter };
    for (const [key, value] of urlParams.entries()) {
      if (value) {
        sufilter[key] =
          value === "null"
            ? null
            : !isNaN(value) && value.trim() !== ""
            ? Number(value)
            : value;
      }
    }
    return sufilter;
  });

  const handleChangePage = (event, newPage) => {
    setFilter((old) => ({
      ...old,
      page: newPage,
    }));
    setDataFetched(false);
  };

  const handleChangeRowsPerPage = (event) => {
    setFilter((old) => ({
      ...old,
      limit: event.target.value,
      page: 0,
    }));
    setDataFetched(false);
  };

  const onChangeFilter = (name, value) => {
    let f = { ...filter };
    f[name] = value;
    setFilter(f);
  };
  const applyFilter = () => {
    setFilter((old) => ({
      ...old,
      page: 0,
    }));
    setDataFetched(false);
  };
  const clearFilter = () => {
    setFilter(defaultFilter);
    setDataFetched(false);
  };
  const updateInUrl = useCallback(
    (aFilters) => {
      let urlKeys = "";
      for (const key in aFilters) {
        if (
          key !== "page" &&
          key !== "limit" &&
          filter[key] &&
          filter[key] !== null &&
          filter[key] !== undefined
        ) {
          urlKeys += urlKeys
            ? `&${key}=${filter[key]}`
            : `${key}=${filter[key]}`;
        }
      }
      navigate(`?${urlKeys}`);
    },
    [filter, navigate]
  );

  useEffect(() => {
    updateInUrl(filter);
  }, [filter, updateInUrl]);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const openUserChangeRow = (event, item) => {
    setAnchorEl(event.currentTarget);
    setSelectedUser(item);
  };
  const closeUserChangeRow = () => {
    setAnchorEl(null);
  };
  const loginMagicLink = (type) => {
    setAnchorEl(null);
    if (!selectedUser) return;
    setLoader(true);
    let parma = {};
    parma["userId"] = userData.userId;
    parma["email"] = selectedUser.email;
    parma["name"] = selectedUser?.name;
    parma["type"] = type;

    EVENTS_SERVICES.loginMagicLink(parma)
      .then((data) => {
        if (data.code === 200) {
          if (data?.data?.link && type === "copy") {
            navigator.clipboard.writeText(data?.data?.link);
            ToastManager.addToast("Login Magic Link Copied!");
          } else {
            ToastManager.addToast("Sent Login Link on Email " + parma?.email);
          }
        } else if (data.code === 600) {
          LOGOUT_USER_SESSION();
          ToastManager.addToast(data?.message);
        } else {
          ToastManager.addToast(data?.message);
        }
      })
      .catch((error) => {
        ToastManager.addToast(error.message);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  useEffect(() => {
    if (userSession) {
      setModulePermissions(getModuleAllPermissions(userSession, module));
      setUserData(userSession);
      GetCountries().then((result) => {
        setCountriesList(result);
      });
    } else {
      setModulePermissions("");
      setUserData("");
    }
    return () => null;
  }, [userSession, module]);

  useEffect(() => {
    if (!userData || dataFetched || !modulePermissions?.view) return;

    setLoader(true);
    setDataFetched(true);

    let parma = { ...filter };
    parma["userId"] = userData.userId;
    EVENTS_SERVICES.getUsers(parma)
      .then((data) => {
        setUserList([]);
        if (data.code === 200) {
          setUserList(data?.data?.list || []);
          if (data?.data.pageInfo.page === 0) {
            setTotalRows(data?.data.pageInfo?.count || 0);
          }
        } else if (data.code === 600) {
          LOGOUT_USER_SESSION();
          ToastManager.addToast(data?.message);
        } else {
          ToastManager.addToast(data?.message);
        }
      })
      .catch((error) => {
        ToastManager.addToast(error.message);
      })
      .finally(() => {
        setLoader(false);
      });
  }, [userData, dataFetched, LOGOUT_USER_SESSION, modulePermissions, filter]);

  useEffect(() => {
    if (userData && !modulePermissions?.view) {
      return navigate("/");
    }
  }, [modulePermissions, userData, navigate]);

  const columns = [
    {
      name: "id",
      label: "Id",
      options: {
        display: false,
      },
    },
    { name: "sno", label: "S.No." },
    {
      name: "name",
      label: "Name",
      options: {
        customBodyRender: (item) => {
          return item?.value ? (
            <Link
              className="text-link"
              to={`/events/users/${item?.id}/profile`}
            >
              {item?.value}
            </Link>
          ) : null;
        },
      },
    },
    {
      name: "profileImage",
      label: "image",
      options: {
        customBodyRender: (value) => {
          return value ? (
            <Avatar style={{ width: "40px" }} src={value} alt="" />
          ) : (
            "-"
          );
        },
      },
    },
    { name: "email", label: "Email" },
    { name: "phoneNumber", label: "Phone" },

    { name: "work", label: "Company" },
    { name: "location", label: "Location" },

    { name: "lastActive", label: "Last seen on 6ix date" },
    { name: "createdAt", label: "First seen on 6ix date" },
    { name: "lastAttendName", label: "Last event attended name" },
    { name: "lastAttendDate", label: "Last event attended date" },
    { name: "lastRegisterName", label: "Last event registered name" },
    { name: "lasteventRegDate", label: "Last event registered date" },
    { name: "lastSpeakerName", label: "Last event spoke name" },
    { name: "lastSpeakerDate", label: "Last event spoke date " },
    {
      name: "eventRegister",
      label: "Number events registered",
      options: {
        customBodyRender: (item) => {
          return item?.value ? (
            <Link
              title="Number events registered"
              to={`/events/users/${item?.id}/registered-events`}
              className="managepro6ix-btn managepro6ix-btn-sm managepro6ix-btn-primary"
            >
              {item?.value}
            </Link>
          ) : (
            0
          );
        },
      },
    },
    {
      name: "eventAttend",
      label: "Number events attended",
      options: {
        customBodyRender: (item) => {
          return item?.value ? (
            <Link
              title="Number events attended"
              to={`/events/users/${item?.id}/attended-events`}
              className="managepro6ix-btn managepro6ix-btn-sm managepro6ix-btn-primary"
            >
              {item?.value}
            </Link>
          ) : (
            0
          );
        },
      },
    },
    {
      name: "eventSpeaker",
      label: "Number events spoke",
      options: {
        customBodyRender: (item) => {
          return item?.value ? (
            <Link
              title="Number events spoke"
              className="managepro6ix-btn managepro6ix-btn-sm managepro6ix-btn-primary"
              to={`/events/users/${item?.id}/speakers-events`}
            >
              {item?.value}
            </Link>
          ) : (
            0
          );
        },
      },
    },

    {
      name: "orgTotal",
      label: "How many orgs are they part of?",
      options: {
        customBodyRender: (item) => {
          return item?.value ? (
            <Link
              title="How many orgs are they part of?"
              className="managepro6ix-btn managepro6ix-btn-sm managepro6ix-btn-primary"
              to={`/events/users/${item?.id}/organizations`}
            >
              {item?.value}
            </Link>
          ) : (
            0
          );
        },
      },
    },
    {
      name: "watchlist",
      label: "Watchlist",
      options: {
        customBodyRender: (item) => {
          return item?.value ? (
            <Link
              className="managepro6ix-btn managepro6ix-btn-sm managepro6ix-btn-primary"
              to={`/events/users/${item?.id}/watchlist`}
              title="Watchlist"
            >
              {item?.value}
            </Link>
          ) : (
            0
          );
        },
      },
    },
    { name: "lastOrgName", label: "What are the name of the org?" },
    { name: "subscription", label: "Are any of the orgs upgraded?" },

    { name: "demoPageView", label: "How many times on demo page? " },
    { name: "demoPageDate", label: "When last date on demo page? " },
    { name: "pricePageView", label: "How many times on pricing page? " },
    { name: "pricePageDate", label: "When last date on pricing page? " },
    { name: "billingPageView", label: "How many times on upgrade page? " },
    { name: "billingPageDate", label: "When last date on upgrade page? " },

    { name: "subscribeStatus", label: "Subbed status " },
    { name: "subscribedDate", label: "When last subbed?  " },
    { name: "unsubscribedDate", label: "When last unsubbed?  " },
    { name: "emailOpenedDate", label: "Date of last email from 6ix opened? " },
    { name: "emailClickedDate", label: "Date of last email from 6ix clicked?" },
    { name: "investorType", label: "Investor Type" },
    { name: "companyWebsite", label: "Company Website" },
    {
      name: "bio",
      label: "Bio",
      options: {
        customBodyRender: (item) => {
          return showFullText === item.id ? (
            <div>
              {item?.text}{" "}
              {item?.text?.length > 50 ? (
                <Button
                  variant="text"
                  color="primary"
                  size="small"
                  onClick={() => setShowFullText("")}
                >
                  Less
                </Button>
              ) : null}
            </div>
          ) : item?.text ? (
            <div>
              {item?.text?.length > 50 ? (
                <>
                  {item?.text.slice(0, 50)} ...
                  <Button
                    variant="text"
                    color="primary"
                    size="small"
                    onClick={() => setShowFullText(item?.id)}
                  >
                    More
                  </Button>
                </>
              ) : (
                item?.text
              )}
            </div>
          ) : null;
        },
      },
    },

    {
      name: "action",
      label: "Action",
      options: {
        customBodyRender: (item) => {
          return (
            <>
              {modulePermissions?.add && (
                <div>
                  <IconButton
                    id={`user-dropdown-button-${item?._id}`}
                    aria-controls={
                      open ? `user-dropdown-menu-${item?._id}` : undefined
                    }
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    onClick={(e) => openUserChangeRow(e, item)}
                  >
                    <MoreHorizIcon />
                  </IconButton>

                  <Menu
                    id={`user-dropdown-menu-${item?._id}`}
                    aria-labelledby={`user-dropdown-menu-${item?._id}`}
                    anchorEl={anchorEl}
                    open={open}
                    onClose={closeUserChangeRow}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "left",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "left",
                    }}
                  >
                    <MenuItem
                      onClick={() => {
                        loginMagicLink("email");
                      }}
                    >
                      <small> Send Login Magic Link via Email</small>
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        loginMagicLink("copy");
                      }}
                    >
                      <small>Copy Login Magic Link</small>
                    </MenuItem>
                  </Menu>
                </div>
              )}
            </>
          );
        },
      },
    },
  ];
  const customOption = {
    pagination: false,
    sort: false,
  };
  const convetFDate = (d, type) => {
    let date = new Date(d);
    if (type === "from") {
      date.setHours(0, 0, 0, 0);
    } else {
      date.setHours(23, 59, 59, 999);
    }
    return date;
  };

  return (
    <>
      {loader && <FullPageProgress />}
      <Box className="managepro6ix-layout-page-content">
        <div className="managepro6ix-layout-page-content-header">
          <div className="managepro6ix-layout-page-content-header-left">
            <div className="managepro6ix-layout-page-content-header-heading">
              6ix Users
            </div>
          </div>
          <div className="managepro6ix-layout-page-content-header-action">
            {userList?.length > 0 ? <EventUserCSV filter={filter} /> : null}
          </div>
        </div>
        <Accordion defaultExpanded>
          <AccordionSummary
            sx={{ marginTop: 2, width: "100px" }}
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography sx={{ textTransform: "uppercase", fontSize: "14px" }}>
              Filters
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={{ xs: 1, md: 2 }}>
              {/* First Row */}
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  label="Name"
                  value={filter?.name}
                  onChange={(e) => onChangeFilter("name", e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  label="Email"
                  value={filter?.email}
                  onChange={(e) =>
                    onChangeFilter(
                      "email",
                      e.target?.value?.toLocaleLowerCase()
                    )
                  }
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <TextField
                  fullWidth
                  label="Phone"
                  value={filter?.phoneNumber}
                  onChange={(e) =>
                    onChangeFilter("phoneNumber", e.target.value)
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Investor Type:
                  </InputLabel>
                  <Select
                    label="Status"
                    name="status"
                    value={filter?.investorType}
                    onChange={(e) =>
                      onChangeFilter("investorType", e.target.value)
                    }
                  >
                    {Object.keys(INVESTOR_TYPE_LIST).map((item, index) => (
                      <MenuItem
                        key={index}
                        value={INVESTOR_TYPE_LIST[item].value}
                      >
                        {INVESTOR_TYPE_LIST[item].name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6} md={2}>
                <TextField
                  fullWidth
                  label="Company Name"
                  value={filter?.work}
                  onChange={(e) => onChangeFilter("work", e.target.value)}
                />
              </Grid>

              <Grid item xs={6} md={2}>
                <TextField
                  fullWidth
                  label="Position"
                  value={filter?.jobTitle}
                  onChange={(e) => onChangeFilter("jobTitle", e.target.value)}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <FormControl fullWidth>
                  <InputLabel htmlFor="fillter-country">Country</InputLabel>

                  <Select
                    id="fillter-country"
                    name="country"
                    className="custom-select"
                    value={filter?.country}
                    onChange={(e) => onChangeFilter("country", e.target.value)}
                    displayEmpty
                  >
                    {countriesList.map((item, key) => (
                      <MenuItem key={key} value={item?.iso2}>
                        {item?.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    fullWidth
                    sx={{ width: "100%" }}
                    label="Joined Date From"
                    format="MMM DD YYYY"
                    value={
                      filter?.createdAtFrom
                        ? dayjs(filter?.createdAtFrom)
                        : null
                    }
                    onChange={(newValue) => {
                      onChangeFilter(
                        "createdAtFrom",
                        newValue?.$d ? convetFDate(newValue?.$d, "from") : null
                      );
                    }}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    fullWidth
                    sx={{ width: "100%" }}
                    label="Joined Date To"
                    format="MMM DD YYYY"
                    value={
                      filter?.createdAtTo ? dayjs(filter?.createdAtTo) : null
                    }
                    onChange={(newValue) => {
                      onChangeFilter(
                        "createdAtTo",
                        newValue?.$d ? convetFDate(newValue?.$d, "to") : null
                      );
                    }}
                    minDate={dayjs(filter?.createdAtFrom)}
                  />
                </LocalizationProvider>
              </Grid>

              <Grid item sx={{ marginTop: 1 }}>
                <button
                  type="button"
                  className="managepro6ix-btn managepro6ix-btn-primary"
                  onClick={applyFilter}
                >
                  Search
                </button>
              </Grid>
              <Grid item sx={{ marginTop: 1 }}>
                <button
                  type="button"
                  className="managepro6ix-btn managepro6ix-btn-primary"
                  onClick={clearFilter}
                >
                  Clear
                </button>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
        <div className="managepro6ix-table-center">
          <DataTable
            customOption={customOption}
            columns={columns}
            data={userList.map((item, key) => {
              return {
                action: item,
                sno: filter?.page * filter?.limit + key + 1,
                name: { id: item?._id, value: item?.name },
                profileImage: item.profileImage,
                email: item.email,
                phoneNumber: item.phoneNumber,
                jobTitle: item.jobTitle,
                work: item.work,
                lastActive: item?.lastActive
                  ? Moment(item?.lastActive).format("MMM DD, YYYY : hh:mm A")
                  : "-",
                createdAt: Moment(item?.createdAt).format(
                  "MMM DD, YYYY : hh:mm A"
                ),
                lastAttendName: item?.lastAttend?.eventName || "-",
                lastAttendDate: item?.lastAttend?.attendDate
                  ? Moment(item?.lastAttend?.attendDate).format(
                      "MMM DD, YYYY : hh:mm A"
                    )
                  : "-",
                lastRegisterName: item?.lastRegister?.eventName || "-",
                lasteventRegDate: item?.lastRegister?.date
                  ? Moment(item?.lastRegister?.date).format(
                      "MMM DD, YYYY : hh:mm A"
                    )
                  : "-",
                eventSpeaker: { id: item?._id, value: item?.eventSpeaker },
                lastSpeakerName: item?.lastSpeaker?.eventName || "-",
                lastSpeakerDate: item?.lastSpeaker?.date
                  ? Moment(item?.lastSpeaker?.date).format(
                      "MMM DD, YYYY : hh:mm A"
                    )
                  : "-",
                eventRegister: { id: item?._id, value: item?.eventRegister },
                eventAttend: { id: item?._id, value: item?.eventAttend },
                orgTotal: { id: item?._id, value: item?.org?.count },
                watchlist: { id: item?._id, value: item?.watchlist },
                lastOrgName: item?.org?.orgName || "-",
                subscription: item?.org?.subscription || 0,

                pricePageView: item?.analytics?.price?.views || 0,
                pricePageDate: item?.analytics?.price?.date
                  ? Moment(item?.analytics?.price?.date).format(
                      "MMM DD, YYYY : hh:mm A"
                    )
                  : "-",
                demoPageView: item?.analytics?.demo?.views || 0,
                demoPageDate: item?.analytics?.demo?.date
                  ? Moment(item?.analytics?.demo?.date).format(
                      "MMM DD, YYYY : hh:mm A"
                    )
                  : "-",
                billingPageView: item?.analytics?.billing?.views || 0,
                billingPageDate: item?.analytics?.billing?.date
                  ? Moment(item?.analytics?.billing?.date).format(
                      "MMM DD, YYYY : hh:mm A"
                    )
                  : "-",
                emailOpenedDate: item?.analytics?.email?.opened
                  ? Moment(item?.analytics?.email?.opened).format(
                      "MMM DD, YYYY : hh:mm A"
                    )
                  : "-",
                emailClickedDate: item?.analytics?.email?.clicked
                  ? Moment(item?.analytics?.email?.clicked).format(
                      "MMM DD, YYYY : hh:mm A"
                    )
                  : "-",
                unsubscribedDate: item?.analytics?.email?.unsubscribed
                  ? Moment(item?.analytics?.email?.unsubscribed).format(
                      "MMM DD, YYYY : hh:mm A"
                    )
                  : "-",
                subscribedDate: Moment(
                  item?.analytics?.email?.subscribed || item?.createdAt
                ).format("MMM DD, YYYY : hh:mm A"),

                subscribeStatus: item?.analytics?.email?.status || "subscribed",

                location:
                  (item?.lastLogin?.city || "") +
                  " " +
                  (item?.lastLogin?.country || ""),
                companyWebsite: item.companyWebsite,
                investorType: item.investorType,
                bio: { text: item.bio, id: item?._id },
                id: item?._id,
              };
            })}
          />
        </div>
        <TablePagination
          component="div"
          count={totalRows}
          page={filter.page}
          onPageChange={handleChangePage}
          rowsPerPage={filter.limit}
          onRowsPerPageChange={handleChangeRowsPerPage}
          showFirstButton={true}
          showLastButton={true}
        />
      </Box>
    </>
  );
}
